import { RAOReportState } from "../store/raoReportReducer";

export const SET_RAO_REPORT = "SET_RAO_REPORT";
export const SET_RAO_F299_SECURED = "SET_RAO_F299_SECURED";
export const SET_RAO_F299_NON_SECURED = "SET_RAO_F299_NON_SECURED";
export const SET_RAO_MW = "SET_RAO_MW";
export const SET_RAO_R1 = "SET_RAO_R1";
export const SET_RAO_R2 = "SET_RAO_R2";
export const SET_RAO_R3_SECURED = "SET_RAO_R3_SECURED";
export const SET_RAO_R3_NON_SECURED = "SET_RAO_R3_NON_SECURED";
export const SET_RAO_R3_ALL_NECS = "SET_RAO_R3_ALL_NECS";
export const SET_RAO_R4 = "SET_RAO_R4";
export const SET_RAO_R5 = "SET_RAO_R5";
export const SET_JUSTIFICATION = "SET_JUSTIFICATION";
export const SET_RAO_SELECTION_RESULT_OBJECTIVE = "SET_RAO_SELECTION_RESULT_OBJECTIVE";
export const SET_RAO_INF_UNBD_FALLBACK = "SET_RAO_INF_UNBD_FALLBACK";
export const SET_INCLUDE_REPORTING_INFO_IN_IVA = "SET_INCLUDE_REPORTING_INFO_IN_IVA";
export const SET_GROM_OPTIMIZER_DATA = "SET_GROM_OPTIMIZER_DATA";
export const SET_KEEP_SENSITIVITIES_DATA = "SET_KEEP_SENSITIVITIES_DATA";

export const SetRAOReport = (rao: RAOReportState) => {
    return { type: SET_RAO_REPORT, rao };
};
export const SetRAOF299Secured = (val: number) => {
    return { type: SET_RAO_F299_SECURED, val };
};
export const SetRAOF299NonSecured = () => {
    return { type: SET_RAO_F299_NON_SECURED };
};
export const SetRAOMW = (e: any) => {
    return { type: SET_RAO_MW, e };
};
export const SetRAOR1 = () => {
    return { type: SET_RAO_R1 };
};
export const SetRAOR2 = () => {
    return { type: SET_RAO_R2 };
};
export const SetRAOR3Secured = () => {
    return { type: SET_RAO_R3_SECURED };
};
export const SetRAOR3NonSecured = () => {
    return { type: SET_RAO_R3_NON_SECURED };
};
export const SetRAOR3AllNecs = () => {
    return { type: SET_RAO_R3_ALL_NECS };
};
export const SetRAOR4 = () => {
    return { type: SET_RAO_R4 };
};
export const SetRAOR5 = () => {
    return { type: SET_RAO_R5 };
};
export const SetJustification = (val: string) => {
    return { type: SET_JUSTIFICATION, val };
};
export const SetRaoSelectionResultObjective = () => {
    return { type: SET_RAO_SELECTION_RESULT_OBJECTIVE };
};
export const SetIncludeReportingInfoInIva = () => {
    return { type: SET_INCLUDE_REPORTING_INFO_IN_IVA };
};
export const SetRaoInfUnbdFallback = () => {
    return { type: SET_RAO_INF_UNBD_FALLBACK };
};
export const SetGromOptimizerData = () => {
    return { type: SET_GROM_OPTIMIZER_DATA };
};
export const SetKeepSensitivitiesData = () => {
    return { type: SET_KEEP_SENSITIVITIES_DATA };
};
